import { ApiStatus } from '../../types';
import { QALiabilityContentDefaultAEM, QALiabilityState } from './qaLiabilityTypes';

export const initialStateQALiability: QALiabilityState = {
    content: QALiabilityContentDefaultAEM,
    qaLiabilityApiStatus: ApiStatus.Idle,
    qaLiabilitySubmitStatus: ApiStatus.Idle,
    qaLiabilityData: {
        categoriesRequired: [],
    },
    validationCheck: false,
    noUserActionIdList: [],
    apiEndpoints: {
        getQALiabilityUrl: '/getQALiabilities',
        submitQALiabilityUrl: '/submitQALiabilities',
    },
};
